import {
  ADD_CAMPAIGN_NOTIFICATION,
  APPROVE_CAMPAIGN_ASYNC,
  CHANGE_DEFAULT_LOCALE_ID,
  CHANGE_END_DATE,
  CHANGE_LAUNCH_DATE,
  CHANGE_LAUNCH_TIME,
  CHANGE_MAX_EMAIL_PER_DAY,
  CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  CHANGE_SEND_REMINDERS_UNTIL,
  CHANGE_TIMEZONE,
  CHANGE_TRAINING_REMINDERS,
  GET_CAMPAIGN_ASYNC,
  INIT_EDIT_MODE,
  PUT_WORKDAYS,
  REMOVE_DRAFT_ASYNC,
  RESET_CAMPAIGN_INPROGRESS_FLAG,
  RESET_CAMPAIGN_TYPE_FLAGS,
  RESET_WIZARD,
  SAVE_AND_APPROVE_CAMPAIGN_ASYNC,
  SAVE_AND_TEST_CAMPAIGN_ASYNC,
  SAVE_DRAFT_ASYNC,
  SET_CONTROLS_MESSAGE,
  SET_TRAINING_VIDEOS,
  TOGGLE_LANDING_PAGE,
  TOGGLE_NOTIFY_THOSE_WHO_FAILED,
  TOGGLE_RANDOMIZED,
  TOGGLE_SCENARIO,
  TOGGLE_SEND_ALL_WEEK,
  TOGGLE_SEND_REMINDER_EVERY_X_BUSINESS_DAYS,
  TOGGLE_SENDING_TYPE,
  TOGGLE_TRAINING_VIDEO,
} from './constants'

export const getCampaign = (id) => ({
  type: GET_CAMPAIGN_ASYNC.INITIATE,
  payload: { id },
})
export const getCampaignSuccess = (data) => ({
  type: GET_CAMPAIGN_ASYNC.SUCCESS,
  payload: { data },
})
export const getCampaignError = (error) => ({
  type: GET_CAMPAIGN_ASYNC.ERROR,
  error,
})
export const getCampaignCancel = () => ({ type: GET_CAMPAIGN_ASYNC.CANCEL })

export const saveDraft = () => ({ type: SAVE_DRAFT_ASYNC.INITIATE })
export const saveDraftSuccess = ({ id }) => ({
  type: SAVE_DRAFT_ASYNC.SUCCESS,
  payload: { id },
})
export const saveDraftError = (error) => ({
  type: SAVE_DRAFT_ASYNC.ERROR,
  error,
})

export const removeDraft = () => ({ type: REMOVE_DRAFT_ASYNC.INITIATE })
export const removeDraftSuccess = (data) => ({
  type: REMOVE_DRAFT_ASYNC.SUCCESS,
  payload: { data },
})
export const removeDraftError = (error) => ({
  type: REMOVE_DRAFT_ASYNC.ERROR,
  error,
})
export const removeDraftCancel = () => ({ type: REMOVE_DRAFT_ASYNC.CANCEL })

export const saveAndApproveCampaign = () => ({
  type: SAVE_AND_APPROVE_CAMPAIGN_ASYNC.INITIATE,
})
export const saveAndApproveCampaignSuccess = (data) => ({
  type: SAVE_AND_APPROVE_CAMPAIGN_ASYNC.SUCCESS,
  payload: { data },
})
export const saveAndApproveCampaignError = (error) => ({
  type: SAVE_AND_APPROVE_CAMPAIGN_ASYNC.ERROR,
  error,
})
export const saveAndApproveCampaignCancel = () => ({
  type: SAVE_AND_APPROVE_CAMPAIGN_ASYNC.CANCEL,
})

export const saveAndTestCampaign = () => ({
  type: SAVE_AND_TEST_CAMPAIGN_ASYNC.INITIATE,
})
export const saveAndTestCampaignSuccess = (data, initialAction) => ({
  type: SAVE_AND_TEST_CAMPAIGN_ASYNC.SUCCESS,
  payload: { data, initialAction },
})
export const saveAndTestCampaignError = (error) => ({
  type: SAVE_AND_TEST_CAMPAIGN_ASYNC.ERROR,
  error,
})
export const saveAndTestCampaignCancel = () => ({
  type: SAVE_AND_TEST_CAMPAIGN_ASYNC.CANCEL,
})

export const approveCampaignSuccess = (data) => ({
  type: APPROVE_CAMPAIGN_ASYNC.SUCCESS,
  payload: { data },
})
export const approveCampaignError = (error) => ({
  type: APPROVE_CAMPAIGN_ASYNC.ERROR,
  error,
})

export const putWorkdays = (workdays) => ({
  type: PUT_WORKDAYS,
  payload: { workdays },
})
export const resetWizard = () => ({ type: RESET_WIZARD })
export const initEditMode = (campaignId) => ({
  type: INIT_EDIT_MODE,
  payload: { campaignId },
})
export const changeDefaultLocaleId = (value) => ({
  type: CHANGE_DEFAULT_LOCALE_ID,
  payload: { value },
})
export const changeTimezone = (value) => ({
  type: CHANGE_TIMEZONE,
  payload: { value },
})
export const changeLaunchDate = (value) => ({
  type: CHANGE_LAUNCH_DATE,
  payload: { value },
})
export const changeLaunchTime = (value) => ({
  type: CHANGE_LAUNCH_TIME,
  payload: { value },
})
export const changeEndDate = (value) => ({
  type: CHANGE_END_DATE,
  payload: { value },
})
export const changeSendRemindersUntil = (value) => ({
  type: CHANGE_SEND_REMINDERS_UNTIL,
  payload: { value },
})
export const changeMaxEmailPerDay = (value) => ({
  type: CHANGE_MAX_EMAIL_PER_DAY,
  payload: { value },
})
export const toggleRandomized = () => ({ type: TOGGLE_RANDOMIZED })
export const toggleSendAllWeek = () => ({ type: TOGGLE_SEND_ALL_WEEK })
export const toggleScenario = (scenario, selected) => ({
  type: TOGGLE_SCENARIO,
  payload: { scenario, selected },
})
export const toggleSendingType = (type) => ({
  type: TOGGLE_SENDING_TYPE,
  payload: { type },
})
export const toggleLandingPage = (landingPage, selected) => ({
  type: TOGGLE_LANDING_PAGE,
  payload: { landingPage, selected },
})
export const toggleTrainingVideo = (trainingVideo, selected) => ({
  type: TOGGLE_TRAINING_VIDEO,
  payload: { trainingVideo, selected },
})
export const resetCampaignInProgress = () => ({
  type: RESET_CAMPAIGN_INPROGRESS_FLAG,
})
export const resetCampaignTypeFlags = () => ({
  type: RESET_CAMPAIGN_TYPE_FLAGS,
})
export const toggleSendReminderEveryXBusinessDays = (value) => ({
  type: TOGGLE_SEND_REMINDER_EVERY_X_BUSINESS_DAYS,
  payload: { value },
})
export const changeParticipantsTotalSelection = (data) => ({
  type: CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  payload: { data },
})
export const toggleSendCampaignFailedEmail = () => ({
  type: TOGGLE_NOTIFY_THOSE_WHO_FAILED,
})
export const changeTrainingReminders = (data) => ({
  type: CHANGE_TRAINING_REMINDERS,
  payload: { data },
})
export const setControlsMessage = (message) => ({
  type: SET_CONTROLS_MESSAGE,
  payload: { message },
})
export const setTrainingVideos = (data) => ({
  type: SET_TRAINING_VIDEOS,
  payload: { data },
})
export const addCampaignNotification = (notification) => ({
  type: ADD_CAMPAIGN_NOTIFICATION,
  payload: { notification },
})

export default {
  // to props
  saveDraft,
  removeDraft,
  saveAndApproveCampaign,
  changeDefaultLocaleId,
  changeTimezone,
  putWorkdays,
  resetWizard,
  initEditMode,
  resetCampaignInProgress,
  resetCampaignTypeFlags,
  changeLaunchDate,
  changeEndDate,
  changeMaxEmailPerDay,
  changeLaunchTime,
}
